import React from 'react';
import FormCard from '../components/FormCard/FormCard';
import { Form, Button, Row, Col } from 'react-bootstrap';
import UploadImage from '../../client/components/ImageUpload';
import {useSelector} from 'react-redux';
import Select from 'react-select';
import { useState, useEffect } from 'react';
import axios from 'axios'
import ReactSelect from 'react-select';
import {useNavigate} from 'react-router-dom';
import PopUpModal from './../../client/components/PopupModal';
import { Alert } from '@mui/material';

export default function AddLocalSellerProducts() {
    const {user} = useSelector((state)=> state.auth);
    const [stores, setStores] = useState();
    const [storeOptions, setStoreOptions] = useState();
    const [category, setCategory] = useState();
    const [categoryOptions, setCategoryOptions] = useState();
    const userId = user.seller_profile_id;
    const [title, setTitle] = useState('')
    const [prodcutType, setprodcutType] = useState('')
    const [color, setcolor] = useState('')
    const [colorOptions, setcolorOptions] = useState();
    const [size, setsize] = useState('')
    const [condition, setcondition] = useState()
    const [costPrice, setcostPrice] = useState('')
    const [salePrice, setsalePrice] = useState('')
    const [discountedPrice, setdiscountedPrice] = useState('')
    const [quantity, setquantity] = useState('')
    const [details, setdetails] = useState('')
    const [file, setFile] = useState(null);
    const getFile = (f)=> {
        setFile(f);
    }
    const [modal, setModal] = useState(false);
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(()=> {
        const getStores = async(id)=> {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/store/get-store/${id}`, {withCredentials: true}).then((res)=> {
                const getData = res.data.map((d)=> ({value: d.seller_shop_id, label: d.seller_store_name}))
                setStoreOptions(getData)
            })
        }
        if(userId) {
            getStores(userId)
        }
    }, [userId])

    useEffect(()=> {
        const getCategory = async()=> {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/category/get-local-seller`, {withCredentials: true}).then((res)=> {
                const getData = res.data.data.map((d)=> ({value: d.category_id, label: d.category_name}))
                setCategoryOptions(getData)
            })
        }
        getCategory()
    }, []);

    useEffect(() => {
        const getColor = async () => {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/color/get`, {withCredentials: true}).then((res) => {
                const getData = res.data.map((d) => ({ value: d.color_id, label: d.color_name }))
                setcolorOptions(getData)
            })
        }
        getColor()
    }, []);

    // Set Title
    useEffect(() => {
        const gettitle = () => {
            setTitle(`${prodcutType ? prodcutType : ""} ${size ? ", " + size : ""} ${color?.label ? ", " + color.label : ""}`);
        }
        gettitle();
    }, [prodcutType, size, color]);

    const handleSubmit = async(e)=> {
        e.preventDefault();
            const newProduct = {
                shop_id: stores.value,
                category_id: category.value,
                name: title,
                local_seller_product_type: prodcutType,
                local_seller_product_size: size,
                color_id: color.value,
                color_name: color.label,
                condition_id: condition.value,
                condition_name: condition.label,
                cost_price: costPrice,
                price: salePrice,
                discounted_price: discountedPrice,
                quantity: quantity,
                details: details
            }
            if(file) {
                const data = new FormData();
                const filename = Date.now() + file.name;
                data.append("name", filename);
                data.append("file", file);
                newProduct.images = filename;
                try {
                await axios.post(process.env.REACT_APP_FIND_API_URL + "/upload", data, {withCredentials: true});
                } catch (error) {
                console.log(error);
                }
            }
        try {
            const res = await axios.post(process.env.REACT_APP_FIND_API_URL + `/localSeller-products/add-localSeller-products`, newProduct, {withCredentials: true});
            if(res.data) {
                setTimeout(()=> setModal(false), 1000);
                setTimeout(()=> navigate('/admin/dashboard'), 1000)
            }
        } catch (error) {
            console.log(error);
            setError(error)
        }
    }

    return (
        <FormCard title="Add Products">
            {<PopUpModal title="Product Added Successfully." show={modal} onHide={() => setModal(false)} />}
            {error && <Alert severity="error">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Select Shop</Form.Label>
                            <Select placeholder="Select Store" options={storeOptions} onChange={(e) => setStores(e)} value={stores} />
                        </Form.Group>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Select Category</Form.Label>
                            <Select placeholder="Select Category" options={categoryOptions} onChange={(e) => setCategory(e)} value={category} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Title</Form.Label>
                            <Form.Control type="text" disabled placeholder="Enter Title" value={title} onChange={(e)=> setTitle(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Product Type</Form.Label>
                            <Form.Control type="text" placeholder="Enter Product Type" value={prodcutType} onChange={(e)=> setprodcutType(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Color</Form.Label>
                            <Select placeholder="Select Color" options={colorOptions} onChange={(e) => setcolor(e)} value={color} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Size</Form.Label>
                            <Form.Control type="text" placeholder="Enter Size" value={size} onChange={(e)=> setsize(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Label>Condition</Form.Label>
                        <ReactSelect placeholder="Select Condition" options={[{value: 1, label: 'New'}, {value: 0, label: 'Old'}]} value={condition} onChange={(e)=> setcondition(e)} />
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Cost Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Cost Price" value={costPrice} onChange={(e)=> setcostPrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Sale Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Sale Price" value={salePrice} onChange={(e)=> setsalePrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Discounted Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Discounted Price" value={discountedPrice} onChange={(e)=> setdiscountedPrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control type="number" placeholder="Enter Quantity" value={quantity} onChange={(e)=> setquantity(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Product Details</Form.Label>
                            <Form.Control as="textarea" placeholder='Enter Product Details...' rows={3} value={details} onChange={(e)=> setdetails(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        { file &&
                            <div>
                                <img className='rounded' width="130px" height="130" src={URL.createObjectURL(file)} alt={file} />
                            </div>
                        }
                        <UploadImage title="Image" getFile={getFile} />
                    </Col>
                </Row>
                <div>
                    <Button variant="primary" type="submit" className="w-100">
                        Submit
                    </Button>
                </div>
            </Form>
        </FormCard>
    )
}
